module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.showDatesPicker) ? _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xl-6"
  }, [_c('label', {
    staticClass: "mr-3 d-inline-flex"
  }, [_vm._v("Dates")]), _vm._v(" "), _c('date-picker-new', {
    staticClass: "dateRangePicker datepicker-align-left",
    attrs: {
      "range": true,
      "disabled": !_vm.group.isEditing || _vm.group.isEditing == false,
      "enableClear": false,
      "clearOutside": true,
      "showFromTo": false
    },
    on: {
      "input": function($event) {
        return _vm.datesChanged($event, _vm.group)
      }
    },
    model: {
      value: (_vm.groupDateRange),
      callback: function($$v) {
        _vm.groupDateRange = $$v
      },
      expression: "groupDateRange"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xl-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n            Duration\n        ")]), _vm._v(" "), _c('duration-picker', {
    attrs: {
      "disabled": !_vm.group.isEditing || _vm.group.isEditing == false
    },
    on: {
      "input": function($event) {
        return _vm.durationChanged(_vm.group)
      }
    },
    model: {
      value: (_vm.group.duration),
      callback: function($$v) {
        _vm.$set(_vm.group, "duration", $$v)
      },
      expression: "group.duration"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.group.schedules), function(schedule, index) {
    return _c('div', {
      staticClass: "col-sm-12 position-relative"
    }, [_c('i', {
      staticClass: "ico-delete fs-large medium pointer removeSchedule",
      class: {
        'opacity-50 notAllowed': !_vm.group.isEditing || _vm.group.isEditing == false && (schedule.id && schedule.id !== null)
      },
      on: {
        "click": function($event) {
          return _vm.removeSchedule(_vm.group, index, schedule)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 panel bg-lighter py-0 px-4"
    }, [_c('div', {
      staticClass: "row my-3"
    }, [_c('div', {
      staticClass: "col-lg-12 col-xl-3 mb-2"
    }, [_c('label', {
      staticClass: "mr-3 d-inline-flex"
    }, [_vm._v("Starts at")]), _vm._v(" "), _c('timepicker', {
      attrs: {
        "defaultTime": _vm.fetchDefaultScheduleStartTime(schedule),
        "availableHours": _vm.durationHourSlots,
        "disabled": !_vm.group.isEditing || _vm.group.isEditing == false
      },
      on: {
        "change": function($event) {
          return _vm.setStartTime($event, schedule)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-lg-12 col-xl-9"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-start flex-wrap weeks-min-height"
    }, [_c('week-day-picker', {
      attrs: {
        "dateRange": _vm.groupDateRange,
        "disabled": (!_vm.group.isEditing || _vm.group.isEditing == false)
      },
      on: {
        "change": function($event) {
          return _vm.weekdaysChanged(schedule)
        },
        "hasWeekDays": function($event) {
          return _vm.setHasWeekDays($event)
        }
      },
      model: {
        value: (schedule.repeatsAtWeekDays),
        callback: function($$v) {
          _vm.$set(schedule, "repeatsAtWeekDays", $$v)
        },
        expression: "schedule.repeatsAtWeekDays"
      }
    })], 1)]), _vm._v(" "), (_vm.featureFlags.showCutoff) ? [_c('div', {
      staticClass: "w-100 border-top-light my-2"
    }), _vm._v(" "), _c('cutoff-manager', {
      attrs: {
        "disabled": (!_vm.group.isEditing || _vm.group.isEditing == false),
        "isCutoffActive": schedule.hasCutOff,
        "selectedChannels": schedule.cutOffChannelsMain,
        "selectedAgents": schedule.cutOffChannelsAgents,
        "cutOffTime": schedule.cutOffTime,
        "softCutOff": schedule.softCutOff
      },
      on: {
        "update:isCutoffActive": function($event) {
          return _vm.$set(schedule, "hasCutOff", $event)
        },
        "update:is-cutoff-active": function($event) {
          return _vm.$set(schedule, "hasCutOff", $event)
        },
        "update:selectedChannels": function($event) {
          return _vm.$set(schedule, "cutOffChannelsMain", $event)
        },
        "update:selected-channels": function($event) {
          return _vm.$set(schedule, "cutOffChannelsMain", $event)
        },
        "update:selectedAgents": function($event) {
          return _vm.$set(schedule, "cutOffChannelsAgents", $event)
        },
        "update:selected-agents": function($event) {
          return _vm.$set(schedule, "cutOffChannelsAgents", $event)
        },
        "update:cutOffTime": function($event) {
          return _vm.$set(schedule, "cutOffTime", $event)
        },
        "update:cut-off-time": function($event) {
          return _vm.$set(schedule, "cutOffTime", $event)
        },
        "update:softCutOff": function($event) {
          return _vm.$set(schedule, "softCutOff", $event)
        },
        "update:soft-cut-off": function($event) {
          return _vm.$set(schedule, "softCutOff", $event)
        },
        "change": function($event) {
          return _vm.scheduleChanged(schedule)
        }
      }
    })] : _vm._e()], 2)])])
  }), _vm._v(" "), (!_vm.group.readOnly) ? _c('div', {
    staticClass: "col-sm-12 mt-3 fs-small bold",
    class: {
      'opacity-50 notAllowed': !_vm.group.isEditing || _vm.group.isEditing == false
    }
  }, [_c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.addRepetition(_vm.group)
      }
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add time")])]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('label', {
    staticClass: "mr-3 d-inline-flex"
  }, [_vm._v("Repeat weekly "), _c('span', {
    staticClass: "brand pl-1"
  }, [_vm._v("*")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-15311798", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15311798"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/ProductScheduleGroupTimeDates.vue
// module id = 1629
// module chunks = 0